import { GenericProducts } from "../../../../constants";

export const PURCHASE_URL = "procurements/operationals/orders/basket/purchase";

// roles that approve/deny purchase requests
export const APPROVERS = ["Sr. Medical Laboratory Scientist", "Chief MLS"];

export const TABS = [
  {
    key: "pending",
    label: "Pending",
    icon: "hourglass-half",
    statuses: ["pending"],
  },
  {
    key: "approved",
    label: "To receive",
    icon: "truck",
    statuses: ["approved"],
  },
  {
    key: "received",
    label: "Received",
    icon: "check-circle",
    statuses: ["received"],
  },
  {
    key: "closed",
    label: "Denied / Cancelled",
    icon: "ban",
    statuses: ["denied", "cancel"],
  },
];

export const STATUS_COLOR = {
  pending: "warning",
  approved: "info",
  received: "success",
  denied: "danger",
  cancel: "light",
};

export const poNumber = ({ _id = "" }) =>
  `PO-${String(_id).slice(-6).toUpperCase()}`;

export const formatDate = (value) =>
  value
    ? new Date(value).toLocaleDateString("en-PH", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";

// "2 box" + "(200 pcs)" for a purchase line
export const qtyLabel = (qty, { unit, unitSize = 1, pgid }) => {
  if (qty === undefined || qty === null) return "—";
  const base = GenericProducts.find(pgid)?.uom === "test" ? "tests" : "pcs";
  const pack = `${qty} ${unit || "unit"}${
    qty === 1 || !unit ? "" : /(s|x|ch|sh)$/i.test(unit) ? "es" : "s"
  }`;
  return unitSize > 1 ? `${pack} (${qty * unitSize} ${base})` : pack;
};

// unit of a purchase line, e.g. "box (100 pcs)"
export const unitLabel = ({ unit, unitSize = 1, pgid }) => {
  const base = GenericProducts.find(pgid)?.uom === "test" ? "tests" : "pcs";
  return unitSize > 1
    ? `${unit || "unit"} (${unitSize} ${base})`
    : unit || base;
};

export const lineName = ({ productId, variantName }) =>
  [productId?.name || "Removed brand", variantName].filter(Boolean).join(" · ");

// "₱1,250.00"
export const peso = (value) =>
  `₱${(Number(value) || 0).toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// latest quantity of a purchase line: received, else approved, else requested
export const lineQty = ({ qnty = {} }) =>
  qnty.received ?? qnty.approved ?? qnty.request ?? 0;
